import { showToast, showImagePreview, Image as VanImage } from 'vant';
import 'vant/es/image-preview/style';
export default {
  data() {
    return {
      viewhight: window.innerHeight - 50
    };
  },
  computed: {},
  components: {
    [showImagePreview.name]: showImagePreview,
    [VanImage.name]: VanImage
  },
  methods: {
    preview() {
      showImagePreview({
        images: ['/img/process.jpg'],
        closeable: true
      });
      //showImagePreview([images:[ '/img/fee.jpg'],closeable:true]);
    },
    onSubmit() {
      showToast('点击结算');
    }
  }
};